/**
 * ErpBillingSummaryWidget — Billing overview for subject dashboard (DRR-321)
 *
 * Shows billing status placeholder. ERP billing data resolved via subgraph.
 * Currently shows a placeholder until ERP integration is complete.
 */

import React from 'react';
import {
  Stack,
  Text,
  Badge,
  Group,
  Alert,
  Paper,
  Box,
  SimpleGrid,
  ThemeIcon,
} from '@mantine/core';
import {
  IconReceipt,
  IconCurrencyDollar,
  IconClock,
} from '@tabler/icons-react';
import type { WidgetProps } from '@ferp/core';

function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

export function ErpBillingSummaryWidget(_props: WidgetProps) {
  // ERP billing data comes from subgraph - show placeholder until integrated
  return (
    <Stack gap="sm">
      <Group gap="xs">
        <IconReceipt size={16} color="var(--mantine-color-blue-6)" />
        <Text fw={600} size="sm">Billing</Text>
        <Badge size="sm" color="green">Current</Badge>
      </Group>

      <SimpleGrid cols={2} spacing="xs">
        <Paper withBorder p="xs" radius="sm">
          <Group gap="xs">
            <ThemeIcon size="sm" variant="light" color="green">
              <IconCurrencyDollar size={14} />
            </ThemeIcon>
            <Box>
              <Text size="xs" c="dimmed">Balance</Text>
              <Text fw={600} size="lg" c="green">
                {formatCurrency(0)}
              </Text>
            </Box>
          </Group>
        </Paper>

        <Paper withBorder p="xs" radius="sm">
          <Group gap="xs">
            <ThemeIcon size="sm" variant="light" color="yellow">
              <IconClock size={14} />
            </ThemeIcon>
            <Box>
              <Text size="xs" c="dimmed">Pending</Text>
              <Text fw={600} size="lg">
                {formatCurrency(0)}
              </Text>
            </Box>
          </Group>
        </Paper>
      </SimpleGrid>

      <Alert icon={<IconReceipt size={16} />} color="blue" variant="light">
        Billing summary available via ERP integration.
      </Alert>
    </Stack>
  );
}
